import { Box, Theme } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  children: ReactNode;
  className?: string;
}

const useStyles = createUseStyles((theme: Theme) => ({
  content: {
    color: theme.palette.darkGray,
  },
}));

const PanelContent: FC<Props> = ({ children, className }) => {
  const styles = useStyles();
  const compClass = classNames(styles.content, className);

  return (
    <Box p={2.5} className={compClass}>
      {children}
    </Box>
  );
};

export default PanelContent;
